var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-chara-root",style:({
  width: (_vm.dispSize + "px"),
  height: (_vm.dispSize + "px"),
  left: ((_vm.x * _vm.stageScale) + "px"),
  top: ((_vm.y * _vm.stageScale) + "px")
})},[_c('div',{staticClass:"item item-hair-back",style:({
    backgroundImage: _vm.hair.imgPath[1] ? ("url(" + (_vm.hair.imgPath[1]) + ")") : 'none'
  })}),_c('div',{staticClass:"item item-body",style:({
    backgroundImage: ("url(" + (_vm.body.imgPath[0]) + ")")
  })}),_c('div',{staticClass:"item item-dress",style:({
    backgroundImage: ("url(" + (_vm.dress.imgPath[0]) + ")")
  })}),_c('div',{staticClass:"item item-face",style:({
    backgroundImage: ("url(" + (_vm.face.imgPath[0]) + ")")
  })}),_c('div',{staticClass:"item item-hair-front",style:({
    backgroundImage: _vm.hair.imgPath[0] ? ("url(" + (_vm.hair.imgPath[0]) + ")") : 'none'
  })}),_c('div',{staticClass:"item item-hair-ear",style:({
    backgroundImage: _vm.hair.imgPath[2] ? ("url(" + (_vm.hair.imgPath[2]) + ")") : 'none'
  })})])}
var staticRenderFns = []

export { render, staticRenderFns }